import { useQuery, useQueryClient } from '@tanstack/react-query'
import { baseUrl } from 'api/config'
import axios from 'axios'
import type { Deals } from '../../types'

interface DealsFilters {
  PK?: string
  SK?: string
  EntityType?: string
  [key: string]: string | undefined
}

export const getDeals = async (endpoint: string, tableName: string, filters: DealsFilters = {}): Promise<Deals[]> => {
  try {
    const url = `${baseUrl}${endpoint}`
    const { data } = await axios.get(url, {
      params: { table: tableName, ...filters }, // Pass filters for PK, SK, or EntityType
    })
    return data || []
  } catch (error) {
    console.error('Error fetching data:', error)
    return [] // Return an empty array in case of an error
  }
}

export const useDeals = (enabled?: boolean, queryKey: string[] = ['deals']) => {
  const queryClient = useQueryClient()
  const existing = queryClient.getQueryData(queryKey)

  // if (existing) {
  //   console.log('[useDeals] Cache hit – skipping fetch')
  // } else {
  //   console.log('[useDeals] Cache miss – fetching deals')
  // }

  const { data: deals, isLoading: isDealsLoading, isError: isDealsError } = useQuery({
    queryKey: queryKey,
    queryFn: () => getDeals('/aws/deals', 'deals'),
    staleTime: Infinity, // Prevent the query from becoming stale
    gcTime: 1000 * 60 * 30, // Cache for 30 minutes
    refetchOnWindowFocus: false, // Prevent refetching when window regains focus
    refetchOnReconnect: false, // Prevent refetching when the network reconnects
    // enabled: enabled ?? false, // Keep this enabled for debugging
    enabled: !existing, // Keep this enabled for debugging
  })
  return { deals, isDealsLoading, isDealsError }
}
